import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  EnvVariables: [],
  EnvStatus: "idle",
  error: null,
};

export const getEnvVariables = createAsyncThunk("env/getEnvVariables", async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/EnvironmentConfig`);
  return response.data;
});

export const envSlice = createSlice({
  name: "env",
  initialState,
  reducers: {
    addEnvVariable: (state, action) => {
      state.EnvVariables.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getEnvVariables.pending, (state) => {
      state.EnvStatus = "loading";
    });
    builder.addCase(getEnvVariables.fulfilled, (state, action) => {
      state.EnvStatus = "env variables loaded";
      const variables = {};
      action.payload.forEach((item) => {
        variables[item.key] = item.value; // Use "item.key" instead of "item.name"
      });

      state.EnvVariables = variables;
    });
    builder.addCase(getEnvVariables.rejected, (state, action) => {
      state.EnvStatus = "loading env variables failed";
      state.error = action.error.message;
    });
  },
});

export const { addEnvVariable } = envSlice.actions;

export default envSlice.reducer;

export const selectAllEnvVariables = (state) => state.env.EnvVariables;
